import * as React from 'react'

import { Box, Button, Form } from '@factorialco/deprecated-design-system'

import TextField from 'modules/core/components/TextField'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { useCreateTagForm } from 'modules/ats/lib/utils/useCreateTagForm'

export const NewTagForm = () => {
  const { company } = useCurrentSession()
  const { createTagForm: form } = useCreateTagForm({ companyId: company.id })

  const submitDisabled = form.isSubmitting || form.values.name === ''

  return (
    <Form onSubmit={form.handleSubmit} padding={null}>
      <Box gap="s8">
        <TextField
          value={form.values.name}
          onChange={(name) => form.setValues({ ...form.values, name })}
          error={form.errors.name}
          label={i18n.t('ats.tags.create_form.name_label')}
        />
        <Box flexDirection="row" justifyContent="flexEnd">
          <Button disabled={submitDisabled} submit>
            {i18n.t('common.save')}
          </Button>
        </Box>
      </Box>
    </Form>
  )
}
